<template>
    <div class="section">    
        <div class="flex-row middle-xs">
            <strong class="col-xs-6">{{  label }}:</strong>
            <strong class="col-xs-6 end-xs">
                {{ value | dinheiro }}
            </strong>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        value: Number,
        label: {
            type: String,
            default: 'TOTAL'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/TotalSimulador.vue